import ListTab, { ListTabItem } from "@/Components/List/ListTab";
import { useState } from "react";
import { Tabs, TabPanel } from "react-tabs";
import PosOrderSettings from "./PosOrderSettings";
import PosOrderUserSettings from "./PosOrderUserSettings";
import { useTranslation } from "react-i18next";

const Settings = () => {
  const { t } = useTranslation("", { keyPrefix: "posOrders" });
  const [tab, setTab] = useState(0);

  return (
    <div>
      <ListTab>
        {[t("posSettings"), t("userSettings")].map((label, index) => (
          <ListTabItem
            key={index}
            onClick={() => setTab(index)}
            active={tab === index}
          >
            {label}
          </ListTabItem>
        ))}
      </ListTab>
      <Tabs selectedIndex={tab}>
        <TabPanel>
          <PosOrderSettings />
        </TabPanel>
        <TabPanel>
          <PosOrderUserSettings />
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default Settings;
